import { useFooterContact } from './useFooterContact';
import { freshCxPhone } from 'src/constants/phoneNumbers';

const newPhoneDisplay = '(646) 780-7957';

export const useSupportLinks = () => {
  const { showPhone, showEmail, supportEmail } = useFooterContact();

  const supportEmailLink = {
    label: supportEmail,
    href: `mailto:${supportEmail}`,
  };
  const supportPhoneLink = {
    label: `Call or Text ${newPhoneDisplay}`,
    href: `tel:${freshCxPhone.link}`,
  };

  return [
    ...(showEmail ? [supportEmailLink] : []), // only show if email is available
    ...(showPhone ? [supportPhoneLink] : []), // only show if phone is available
  ];
};
